module.exports = __webpack_public_path__ + "img/图片11.25a3222d.png";